import React, { Component } from "react";
export default class NetDetect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: !window.navigator.onLine
        }
    }
    render() {
        //console.log("ooo", this.state.visible);
        return (
            <div style={{ position: "fixed", zIndex: 1000, left: 0, bottom: 0, width: "100%" }}>
                {this.state.visible ?
                    <div id="netDetect">
                        <h2>No internet connection detected !! You are now offline.</h2>
                    </div>
                    : null}
            </div>
        )
    }
    handleOnline() {
        this.setState({ visible: false });
    }
    handleOffline() {
        this.setState({ visible: true });
    }
    componentDidMount() {
        // window.navigator.onli
        window.addEventListener("offline", this.handleOffline.bind(this));
        window.addEventListener("online", this.handleOnline.bind(this))
    }
}



// WEBPACK FOOTER //
// ./src/jsx/components/utility/net-detect.jsx